module.exports = __webpack_public_path__ + "5e66287d4518de3243f07d41d36047ed.svg";